import React from "react"

const CardLoading = () => {
  return (
    <>
      {[1, 2, 3].map(key => (
        <div className="cardLoading" key={key}>
          <div>loading</div>
          <div>loading</div>
        </div>
      ))}
    </>
  )
}

export default CardLoading
